export default "__VITE_ASSET__Dg6uT0GT__"